import type { ChangePerformanceKitView, EquipmentChange } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import type { ChangeSelectedWheelsForm, ChangeSelectedWheelsProps } from "src/hooks"
import { useChangePerformanceKitProps } from "src/hooks"
import type { FormWithProps } from "src/types/FormWithProps"
import { useChangePerformanceKitForm } from "./useChangePerformanceKitForm"

interface UseChangePerformanceKitProps {
	view: ChangePerformanceKitView
}

export interface UseChangePerformanceKitReturn {
	formWithProps: FormWithProps<ChangeSelectedWheelsForm, ChangeSelectedWheelsProps>
	getChange: () => Pick<EquipmentChange, "setPerformanceKit">
}

export const useChangePerformanceKit = ({ view }: UseChangePerformanceKitProps): UseChangePerformanceKitReturn => {
	const form = useChangePerformanceKitForm({ view })
	const props = useChangePerformanceKitProps({ view })

	const getChange = useCallback((): Pick<EquipmentChange, "setPerformanceKit"> => {
		const optionCode = form.watch("optionCode") || null
		return optionCode !== view.option.optionCode
			? {
					setPerformanceKit: { optionCode },
				}
			: { setPerformanceKit: undefined }
	}, [form, view.option.optionCode])

	return {
		formWithProps: { form, props },
		getChange,
	}
}
